import { render, staticRenderFns } from "./sales-chart.vue?vue&type=template&id=67d41cf0"
import script from "./sales-chart.vue?vue&type=script&lang=js"
export * from "./sales-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports